<template>
    <div class="platform-info">
        <div class="platform-table">
            <el-table :data="tableData" border>
                <el-table-column label="序号" type="index" width="80"></el-table-column>
                <el-table-column label="平台" prop="platform"></el-table-column>
                <el-table-column label="国家" prop="country"></el-table-column>
                <el-table-column label="产品类型/分类" prop="category"></el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleDetail(scope.row)">详情</el-button>
                        <el-button type="text" @click="handleDelete(scope.row)">移除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-button type="text" icon="el-icon-plus" @click="handleAdd">添加</el-button>
        </div>

        <div class="platform-form" v-if="showForm">
            <el-tabs v-model="activeTab">
                <el-tab-pane label="序号" name="index"></el-tab-pane>
                <el-tab-pane label="必填项" name="required"></el-tab-pane>
                <el-tab-pane label="非必填项" name="optional"></el-tab-pane>
            </el-tabs>

            <div class="form-content">
                选择产品类型/分类后的属性信息
            </div>

            <div class="form-footer">
                <el-button type="primary" @click="handleSave">保存</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PlatformInfo',
    data() {
        return {
            tableData: [],
            showForm: false,
            activeTab: 'index'
        }
    },
    methods: {
        handleDetail(row) {
            this.showForm = true
        },
        handleDelete(row) {
            // 处理删除逻辑
        },
        handleAdd() {
            this.showForm = true
        },
        handleSave() {
            // 处理保存逻辑
            this.showForm = false
        }
    }
}
</script>